/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BookNotepadIcon24Regular = forwardRef('BookNotepadIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M10.5 7a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5Z" }),
        React.createElement("path", { d: "M9.75 10.75a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75Z" }),
        React.createElement("path", { d: "M10.5 13a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.25 6A3.75 3.75 0 0 1 7 2.25h9A3.75 3.75 0 0 1 19.75 6v12A3.75 3.75 0 0 1 16 21.75H7A3.75 3.75 0 0 1 3.25 18V6Zm1.5 0c0-.98.626-1.813 1.5-2.122v16.244A2.251 2.251 0 0 1 4.75 18V6Zm3-2.25v16.5H16A2.25 2.25 0 0 0 18.25 18V6A2.25 2.25 0 0 0 16 3.75H7.75Z" })));
});
